import { Role } from "../../../Helpers/AuthorizationDataProvider";

export enum TabStatus{
	Error = 'Error',
	Loaded = 'Loaded',
	Loading = 'Loading',
}

export interface UpgradeRequest {
	createdBy: {
		firstName: string
		imageId?: string
		isActive: boolean
		isDeleted: boolean
		lastName: string
		location: string
		reinvite: boolean
		rocketUserId: string
		role: Role
		userId: string
	}
	upgradeApplicantMentee: {
		conference: string
		createdAt: string
		firstName: string
		id: string
		lastName: string
		status: Status
		userId: string
	}
}

export enum Status {
	Pending = 'Pending',
	Active = 'Active',
	Rejected = 'Rejected',
	Accepted = 'Accepted',
}

export interface TableData {
	createdAt: string
	id: string
	imageId?: string
	name: string
	status: Status
	userId: string
}